
    // Update dynamic content when language changes
    import i18next from './src/locales/i18n.js';

    function updateSkipLink() {
      const skipLink = document.getElementById('skip-link');
      if (skipLink) {
        skipLink.textContent = i18next.t('common.skipToMain');
      }
    }

    function updateMetaDescription() {
      const metaDescription = document.getElementById('meta-description');
      if (metaDescription) {
        metaDescription.setAttribute('content', i18next.t('seo.description'));
      }
    }

    function updateContent() {
      updateSkipLink();
      updateMetaDescription();
    }

    i18next.on('initialized', updateContent);
    i18next.on('languageChanged', updateContent);
  